module.exports = __webpack_public_path__ + "img/pitch-plan.9b3ef40c.jpg";